(function() {
    'use strict';

    angular
        .module('capacitacionCertificacionApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
